export default __webpack_public_path__ + "static/Borjan-21ca0f1afdd5e9a440d433b75ac75519.jpg";